import styled from "styled-components";

export const PatentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;

  img {
    width: 120px;
    height: auto;
    transition: transform 0.2s ease;
  }
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & h6 {
    font-size: 1.8rem !important;
  }
  margin-bottom: 30px;
`;

export const BrandGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  justify-items: center;
  align-items: center;
  margin-top: 20px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr); // 모바일에서 2열
    gap: 16px; // 모바일에서 간격 축소
  }
`;

export const BrandBox = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 130px;
    height: auto;
  }
`;

export const BannerWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;

  img {
    max-width: 1200px;
    width: 100%;
    height: auto;
    border-radius: 8px;
    transition: transform 0.2s ease;
  }

  &:hover img {
    transform: scale(1.05);
    cursor: pointer;
  }
`;

export const ProductListWrapper = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr;
  flex-wrap: wrap;
  gap: 25px;
  justify-content: center;

  @media (max-width: 768px) {
    margin-top: 20px;
    gap: 10px;
  }
`;

export const ProductBox = styled.div`
  width: 100%;
  height: auto;
  cursor: pointer;

  img {
    width: 100%;
    height: auto;
    border: 1px solid #ededed;
    border-radius: 16px;
    transition: transform 0.2s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;
